//import React from 'react';
const PAGE = [
  {
    "content": `Aprobar`
  }
];




  
export default PAGE;